export const JobContactFields = ({ email, mobile, onChange }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="appointment-contact-fields">
    <label className="block text-white text-sm" htmlFor="job-contact-email">Email (optional)
      <input id="job-contact-email" type="email" name="customer_email" data-testid="appointment-email-input"
        className="retro-input w-full mt-2" value={email} onChange={onChange} autoComplete="email" />
    </label>
    <label className="block text-white text-sm" htmlFor="job-contact-mobile">Phone/mobile (optional)
      <input id="job-contact-mobile" type="tel" name="customer_mobile" data-testid="appointment-mobile-input"
        className="retro-input w-full mt-2" value={mobile} onChange={onChange} maxLength={80} autoComplete="tel" />
    </label>
  </div>
);